import { render, staticRenderFns } from "./DetailNews.html?vue&type=template&id=60619752&scoped=true&external"
import script from "./DetailNews.vue?vue&type=script&lang=js"
export * from "./DetailNews.vue?vue&type=script&lang=js"
import style0 from "./DetailNews.scss?vue&type=style&index=0&id=60619752&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60619752",
  null
  
)

export default component.exports